// This file is generated by pnpm icons:generate. Do not edit.

import {createSinglePathSVG} from './TEMPLATE'

export const TextSize_Stroke2_Corner0_Rounded = createSinglePathSVG({
  path: 'M8.179 4.93a.75.75 0 0 0-1.358 0l-6 12.75a.75.75 0 1 0 1.358.639L3.74 15h7.518l1.562 3.319a.75.75 0 1 0 1.358-.639ZM4.447 13.5 7.5 7.012l3.053 6.488ZM18.75 9c-1.196 0-2.13.325-2.778.968a.75.75 0 0 0 1.056 1.064c.356-.353.937-.532 1.722-.532 1.24 0 2.25.844 2.25 1.875v.302A4 4 0 0 0 18.75 12C16.682 12 15 13.514 15 15.375s1.682 3.375 3.75 3.375a4 4 0 0 0 2.25-.68.75.75 0 0 0 1.5-.07v-5.625C22.5 10.515 20.818 9 18.75 9Zm0 8.25c-1.24 0-2.25-.844-2.25-1.875s1.01-1.875 2.25-1.875 2.25.844 2.25 1.875-1.01 1.875-2.25 1.875Z',
  viewBox: '0 0 24 24',
  glyph: 'TextSize_Stroke2_Corner0_Rounded',
})
